(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-mission"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.about-mission').forEach(function(section) {
    var logo = section.querySelector('.about-mission__logo');
    var logoImg = section.querySelector('.about-mission__logo-image');
    var logoSvgContainer = section.querySelector('.about-mission__logo > div');
    var logoSvg = section.querySelector('.about-mission__logo svg');

    var desktopSize = parseInt(section.dataset.logoSizeDesktop) || 40;
    var mobileSize = parseInt(section.dataset.logoSizeMobile) || 35;
    var desktopMargin = parseInt(section.dataset.logoMarginDesktop) || 50;
    var mobileMargin = parseInt(section.dataset.logoMarginMobile) || 40;

    function updateLogoSize() {
      var isDesktop = window.innerWidth >= 750;
      var size = isDesktop ? desktopSize : mobileSize;
      var margin = isDesktop ? desktopMargin : mobileMargin;

      if (logo) logo.style.marginTop = margin + 'px';
      if (logoImg) logoImg.style.maxWidth = size + 'px';
      if (logoSvgContainer) {
        logoSvgContainer.style.width = size + 'px';
        logoSvgContainer.style.height = size + 'px';
      }
      if (logoSvg) {
        logoSvg.setAttribute('width', size);
        logoSvg.setAttribute('height', size);
      }
    }

    updateLogoSize();
    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateLogoSize, 250);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-faqs-page"] && !Shopify.designMode) return;
  try {
    
(function() {
  var section = document.querySelector('.faqs-page');
  if (!section) return;

  var tabs = section.querySelectorAll('.faqs-tab');
  var questions = section.querySelectorAll('.faqs-accordion');

  function setActiveTab(category) {
    /* Update tabs */
    tabs.forEach(function(tab) {
      if (tab.getAttribute('data-category') === category) {
        tab.classList.add('active');
      } else {
        tab.classList.remove('active');
      }
    });

    /* Filter questions */
    questions.forEach(function(q) {
      var qCat = q.getAttribute('data-category');
      if (qCat && qCat.toLowerCase() === category.toLowerCase()) {
        q.removeAttribute('hidden');
      } else {
        q.setAttribute('hidden', '');
        q.removeAttribute('open');
      }
    });
  }

  /* Attach click listeners */
  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      setActiveTab(this.getAttribute('data-category'));
    });
  });

  /* Default: activate first category tab */
  if (tabs.length) {
    setActiveTab(tabs[0].getAttribute('data-category'));
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-find-bag"]) return;
  try {
    
(function() {
  document.querySelectorAll('.find-bag').forEach(function(section) {
    var filters = section.querySelector('[data-find-bag-filters]');
    var carousel = section.querySelector('[data-find-bag-carousel]');
    var dotsContainer = section.querySelector('[data-find-bag-dots]');
    var cards = carousel ? Array.from(carousel.querySelectorAll('.find-bag__card')) : [];

    // Filter functionality
    if (filters) {
      var buttons = Array.from(filters.querySelectorAll('.find-bag__filter-btn'));
      buttons.forEach(function(btn) {
        btn.addEventListener('click', function() {
          buttons.forEach(function(b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');

          var filter = btn.getAttribute('data-filter');
          cards.forEach(function(card) {
            if (filter === 'all' || card.getAttribute('data-bag-type') === filter) {
              card.classList.remove('is-hidden');
            } else {
              card.classList.add('is-hidden');
            }
          });

          updateDots();
        });
      });
    }

    // Dots for mobile
    function updateDots() {
      if (!dotsContainer) return;
      dotsContainer.innerHTML = '';
      var visibleCards = cards.filter(function(c) { return !c.classList.contains('is-hidden'); });
      if (window.innerWidth >= 768 || visibleCards.length <= 1) return;

      visibleCards.forEach(function(card, i) {
        var dot = document.createElement('button');
        dot.className = 'find-bag__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', function() {
          card.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        });
        dotsContainer.appendChild(dot);
      });
    }

    // Update active dot on scroll
    if (carousel) {
      var scrollTimer;
      carousel.addEventListener('scroll', function() {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function() {
          var dots = dotsContainer ? Array.from(dotsContainer.querySelectorAll('.find-bag__dot')) : [];
          var visibleCards = cards.filter(function(c) { return !c.classList.contains('is-hidden'); });
          if (dots.length === 0) return;

          var carouselRect = carousel.getBoundingClientRect();
          var center = carouselRect.left + carouselRect.width / 2;
          var closestIdx = 0;
          var closestDist = Infinity;

          visibleCards.forEach(function(card, i) {
            var cardRect = card.getBoundingClientRect();
            var cardCenter = cardRect.left + cardRect.width / 2;
            var dist = Math.abs(cardCenter - center);
            if (dist < closestDist) {
              closestDist = dist;
              closestIdx = i;
            }
          });

          dots.forEach(function(d, i) {
            d.classList.toggle('is-active', i === closestIdx);
          });
        }, 100);
      });
    }

    // Klaviyo notify button
    section.querySelectorAll('[data-klaviyo-trigger]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'SRCgwE']);
      });
    });

    updateDots();
    window.addEventListener('resize', updateDots);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-lp-faqs"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.c-lp-faqs').forEach(function(section) {
    section.querySelectorAll('[data-faq-toggle]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = btn.closest('[data-faq-item]');
        var wasOpen = item.classList.contains('is-open');

        // Close all items in this section
        section.querySelectorAll('[data-faq-item]').forEach(function(el) {
          el.classList.remove('is-open');
        });

        // Toggle clicked item
        if (!wasOpen) {
          item.classList.add('is-open');
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-main-article"]) return;
  try {
    
(function() {
  /* Share button — copy article URL to clipboard */
  var shareBtn = document.querySelector('[data-share]');
  var tooltip = document.querySelector('[data-share-tooltip]');
  if (shareBtn) {
    shareBtn.addEventListener('click', function() {
      var url = window.location.href;
      if (navigator.share) {
        navigator.share({ title: document.title, url: url });
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function() {
          if (tooltip) {
            tooltip.hidden = false;
            tooltip.classList.add('is-visible');
            setTimeout(function() {
              tooltip.classList.remove('is-visible');
              setTimeout(function() { tooltip.hidden = true; }, 300);
            }, 2000);
          }
        });
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-main-blog"]) return;
  try {
    
(function() {
  var btn = document.getElementById('toggle-sidebar');
  var sidebar = document.getElementById('blog-sidebar');
  if (btn && sidebar) {
    btn.addEventListener('click', function() {
      sidebar.classList.toggle('open');
    });
    /* Close sidebar when clicking outside on mobile */
    document.addEventListener('click', function(e) {
      if (sidebar.classList.contains('open') && !sidebar.contains(e.target) && e.target !== btn) {
        sidebar.classList.remove('open');
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["see-it-in-action"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('see-it-in-action')) {
    class SeeItInAction extends HTMLElement {
      connectedCallback() {
        this.player = this.querySelector('[data-siia-player]');
        if (!this.player) return;

        this.video = this.player.querySelector('[data-siia-video]');
        this.cards = this.player.querySelector('[data-siia-cards]');
        this.cardsWrap = this.player.querySelector('[data-siia-cards-wrap]');
        this.cardsNav = this.player.querySelector('[data-siia-cards-nav]');
        this.dots = this.player.querySelector('[data-siia-dots]');
        this.progress = this.player.querySelector('[data-siia-progress]');
        this.pausedIcon = this.player.querySelector('[data-siia-paused]');
        this.muteButton = this.player.querySelector('[data-siia-mute]');
        this.prevButton = this.player.querySelector('[data-siia-prev]');
        this.nextButton = this.player.querySelector('[data-siia-next]');
        this.count = this.player.querySelector('[data-siia-count]');
        this.index = 0;
        this.mobile = window.matchMedia('(max-width: 749px)');

        this.addEventListener('click', this.onThumbClick);
        this.player.addEventListener('click', this.onPlayerClick);
        this.video.addEventListener('ended', this.onEnded);
        this.video.addEventListener('click', this.togglePlay);
        this.video.addEventListener('play', this.syncControls);
        this.video.addEventListener('pause', this.syncControls);
        this.video.addEventListener('volumechange', this.syncControls);
        this.video.addEventListener('timeupdate', this.onTimeUpdate);
        this.cards.addEventListener('scroll', this.syncCardNav, { passive: true });
      }

      disconnectedCallback() {
        this.close();
        // The player lives on <body> while open; don't leave an orphan behind (theme editor re-renders).
        if (this.player && this.player.parentElement === document.body) this.player.remove();
      }

      get thumbs() {
        return Array.from(this.querySelectorAll('[data-siia-thumb]'));
      }

      onThumbClick = (event) => {
        const thumb = event.target.closest('[data-siia-thumb]');
        if (!thumb) return;
        this.open(this.thumbs.indexOf(thumb));
      };

      onPlayerClick = (event) => {
        if (event.target.closest('[data-siia-close]')) return this.close();
        if (event.target.closest('[data-siia-prev]')) return this.show(this.index - 1);
        if (event.target.closest('[data-siia-next]')) return this.show(this.index + 1);

        if (event.target.closest('[data-siia-mute]')) return (this.video.muted = !this.video.muted);
        if (event.target.closest('[data-siia-card-prev]')) return this.scrollCards(this.cardIndex - 1);
        if (event.target.closest('[data-siia-card-next]')) return this.scrollCards(this.cardIndex + 1);

        const dot = event.target.closest('[data-siia-dot]');
        if (dot) return this.scrollCards(Number(dot.dataset.siiaDot));

        const addButton = event.target.closest('[data-siia-add]');
        if (addButton) this.addToCart(addButton);
      };

      togglePlay = () => {
        if (this.video.paused) this.video.play().catch(() => {});
        else this.video.pause();
      };

      syncControls = () => {
        // "ended" also pauses; don't flash the play icon while auto-advancing.
        this.pausedIcon.hidden = !this.video.paused || this.video.ended || !this.video.currentSrc;
        this.muteButton.setAttribute('aria-pressed', String(this.video.muted));
        this.muteButton.setAttribute('aria-label', this.video.muted ? 'Unmute' : 'Mute');
      };

      onTimeUpdate = () => {
        const { currentTime, duration } = this.video;
        this.progress.style.width = duration ? `${(currentTime / duration) * 100}%` : '0';
      };

      get cardIndex() {
        return this.cards.clientWidth ? Math.round(this.cards.scrollLeft / this.cards.clientWidth) : 0;
      }

      scrollCards(index) {
        this.cards.scrollTo({ left: index * this.cards.clientWidth, behavior: 'smooth' });
      }

      syncCardNav = () => {
        const index = this.cardIndex;
        const last = this.dots.children.length - 1;
        Array.from(this.dots.children).forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
        this.player.querySelector('[data-siia-card-prev]').disabled = index <= 0;
        this.player.querySelector('[data-siia-card-next]').disabled = index >= last;
      };

      onEnded = () => {
        if (this.index < this.thumbs.length - 1) this.show(this.index + 1);
      };

      onKeydown = (event) => {
        if (event.key === 'Escape') this.close();
        if (event.key === 'ArrowLeft') this.show(this.index - 1);
        if (event.key === 'ArrowRight') this.show(this.index + 1);
      };

      open(index) {
        this.lastFocused = document.activeElement;
        if (this.player.parentElement !== document.body) document.body.appendChild(this.player);
        this.player.hidden = false;
        if (this.mobile.matches) document.documentElement.style.overflow = 'hidden';
        document.addEventListener('keydown', this.onKeydown);
        this.show(index);
        this.player.querySelector('[data-siia-close]').focus({ preventScroll: true });
      }

      close() {
        if (!this.player || this.player.hidden) return;
        this.video.pause();
        this.video.removeAttribute('src');
        this.video.load();
        this.player.hidden = true;
        document.documentElement.style.overflow = '';
        document.removeEventListener('keydown', this.onKeydown);
        if (this.lastFocused instanceof HTMLElement) this.lastFocused.focus({ preventScroll: true });
      }

      show(index) {
        const thumbs = this.thumbs;
        if (index < 0 || index >= thumbs.length) return;

        const thumb = thumbs[index];
        this.index = index;
        this.progress.style.width = '0';
        this.video.poster = thumb.dataset.videoPoster || '';
        this.video.src = thumb.dataset.videoSrc;
        // Opened from a tap/click, so playing with sound is allowed; fall back to muted if the browser refuses.
        this.video.play().catch(() => {
          this.video.muted = true;
          this.video.play().catch(() => {});
        });

        this.renderCards(thumb);
        this.prevButton.disabled = index === 0;
        this.nextButton.disabled = index === thumbs.length - 1;
        this.count.textContent = `${index + 1} / ${thumbs.length}`;
      }

      renderCards(thumb) {
        const template = thumb.parentElement.querySelector('[data-siia-cards-template]');
        this.cards.replaceChildren(template ? template.content.cloneNode(true) : '');
        const cardCount = this.cards.querySelectorAll('[data-siia-card]').length;
        const multiple = cardCount > 1;

        this.cardsWrap.hidden = cardCount === 0;
        this.cardsWrap.classList.toggle('see-it-in-action__cards-wrap--multiple', multiple);
        this.cardsNav.hidden = !multiple;
        this.dots.hidden = !multiple;
        this.dots.replaceChildren(
          ...Array.from({ length: multiple ? cardCount : 0 }, (_, i) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'see-it-in-action__dot';
            dot.dataset.siiaDot = String(i);
            dot.setAttribute('aria-label', `Show product ${i + 1} of ${cardCount}`);
            return dot;
          })
        );
        this.cards.scrollLeft = 0;
        this.syncCardNav();
      }

      addToCart(button) {
        let variantId = button.dataset.variantId;
        // The page's own product: prefer whatever variant is currently selected in the product form.
        if (button.hasAttribute('data-use-form-variant')) {
          const formInput = document.querySelector('product-form-component input[name="id"], form[action*="/cart/add"] input[name="id"]');
          if (formInput && formInput.value) variantId = formInput.value;
        }
        if (!variantId) return;

        const label = button.dataset.label;
        const reset = () => setTimeout(() => {
          button.textContent = label;
          button.disabled = false;
        }, 1500);

        button.disabled = true;
        button.textContent = 'Adding...';

        const cartItems = document.querySelector('cart-items-component[data-section-id]');
        const body = { items: [{ id: parseInt(variantId, 10), quantity: 1 }] };
        if (cartItems) body.sections = cartItems.getAttribute('data-section-id');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        })
          .then((response) => response.json().then((json) => ({ ok: response.ok, json })))
          .then(({ ok, json }) => {
            if (!ok) throw new Error(json.description || json.message || 'Add to cart failed');

            button.textContent = 'Added!';
            document.dispatchEvent(
              new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  resource: json,
                  sourceId: variantId,
                  data: { source: 'see-it-in-action', sections: json.sections || {} },
                },
              })
            );

            // Full-screen player would sit on top of the drawer on mobile; on desktop the drawer covers it.
            if (this.mobile.matches) this.close();
            else this.video.pause();
            const cartDrawer = document.querySelector('cart-drawer-component');
            if (cartDrawer && typeof cartDrawer.open === 'function') cartDrawer.open();
            reset();
          })
          .catch(() => {
            button.textContent = 'Error';
            reset();
          });
      }
    }

    customElements.define('see-it-in-action', SeeItInAction);
  }

  } catch(e) { console.error(e); }
})();
})();
